import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function nipValidator(optional: boolean): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const nip = control.value;

    if (optional && (nip === null || nip === '')) {
      return null;
    }

    if (nip.length !== 10) {
      return { invalidLength: nip.length };
    }
    let weight = [6, 5, 7, 2, 3, 4, 5, 6, 7];
    let sum = 0;
    weight.forEach((value: number, index: number) => sum = sum + value * Number(nip[index]));

    if ((sum % 11) !== Number(nip[9])) {
      return { invalidNip: nip };
    }

    return null;
  };
}
